/**
 * Design system colors as literal values, for APIs that can't read CSS variables
 * (Google Maps markers, canvas). Everywhere else, use the Tailwind tokens
 * (bg-primary, text-destructive) or hsl(var(--primary)). Keep in sync with
 * src/index.css and docs/design-system.md Part 2.
 */
export const BRAND_NAVY = '#2a3749'; // --primary
export const BRAND_RED = '#c33349'; // --destructive, danger only

// Supporting shades for MUI's palette, which needs literal light/dark variants.
export const BRAND_NAVY_LIGHT = '#55657b';
export const BRAND_NAVY_DARK = '#1c2533';
export const BRAND_RED_LIGHT = '#d4687a';
export const BRAND_RED_DARK = '#9c2a3b';
export const ICE = '#ddedfa'; // --accent, hover and selected
